<nb-card style="height: 100%;">
        <nb-card-header style="padding: 5px;">
            Tasks Completed
            <br> By Month
        </nb-card-header> 
        <nb-card-body [nbSpinner]="isLoading">
            <div style="width: 100%;">
                    <canvas
                        baseChart
                        [type]="'bar'"
                        [datasets]="chartData"
                        [labels]="chartLabels"
                        [options]="chartOptions"
                        [legend]="true">
                        <!-- TODO Upgrade [colors]="myColors"  -->
                    </canvas>
                  </div>
        </nb-card-body> 
    </nb-card>